<template>
  <div>
    <div class="row">
      <div class="col-md-12 header-row">
        <h3 class="heading semi-bold">{{ categoryName }}</h3>
        <div class="row">
          <div class="col-md-3">
            <div class="input-group transparent">
              <span class="input-group-addon">
                <i class="fa fa-search" aria-hidden="true"></i>
              </span>
              <input
                type="text"
                class="form-control search-fabric"
                @keyup.enter="searchBookFabric($event.target.value)"
                placeholder="Search book ..."
              />
            </div>
          </div>
          <div class="col-md-9 text-right">
            <router-link
              :to="{ name: 'fabric_book_create', params: { id: categoryId } }"
              class="btn shadow btn-primary create-new"
              v-if="!isReadOnlyUser"
            >
              <i class="fa fa-plus-circle" aria-hidden="true"></i> Create a Book
            </router-link>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="grid shadow bg-white mt-20">
          <div class="grid-body">
            <div class="row">
              <div
                class="col-md-12 text-right mb-10 bulk-actions"
                v-if="!isReadOnlyUser"
              >
                with selected
                <button
                  class="btn btn-danger"
                  @click="deleteSelected()"
                  :disabled="selectedBooks.length == 0"
                >
                  Delete
                </button>
                <button
                  class="btn btn-primary"
                  @click="updateSelected()"
                  :disabled="selectedBooks.length == 0"
                >
                  Update Visibility
                </button>
              </div>

              <div class="col-md-12">
                <div class="table-div">
                  <div class="book-list">
                    <div class="book-list-header">
                      <div class="row">
                        <div class="col-md-1"></div>
                        <div class="col-md-1"></div>
                        <div class="col-md-1 text-center">ID</div>
                        <div class="col-md-3">Title</div>
                        <div class="col-md-1 text-center">Visibility</div>
                        <div class="col-md-1 text-center">Num fabrics</div>
                        <div class="col-md-1 text-center">Likes</div>
                        <div class="col-md-1"></div>
                        <div class="col-md-1"></div>
                        <div class="col-md-1"></div>
                      </div>
                    </div>
                    <div class="book-list-body">
                      <draggable
                        v-if="books.length > 0"
                        :list="books"
                        tag="div"
                        @sort="updateBookOrder"
                      >
                        <div
                          v-for="(book, index) in books"
                          :key="book.id"
                          class="row"
                        >
                          <div class="col-md-1">
                            <input
                              type="checkbox"
                              :value="book"
                              v-model="selectedBooks"
                            />
                          </div>
                          <div class="col-md-1">
                            <span class="sort-handle"
                              ><i class="fa fa-bars"></i
                            ></span>
                          </div>
                          <div class="col-md-1 text-center">{{ book.id }}</div>
                          <div class="col-md-3">{{ book.title }}</div>
                          <div class="col-md-1 text-center">
                            <span
                              :class="
                                'badge badge-' +
                                getVisibilityColor(book.visibility)
                              "
                              >{{ book.visibility }}</span
                            >
                          </div>
                          <div class="col-md-1 text-center">
                            {{ book.fabrics.length }}
                          </div>
                          <div class="col-md-1 text-center">
                            {{ book.likes }}
                          </div>
                          <div class="col-md-1 text-center">
                            <router-link
                              :to="{
                                name: 'fabric_book_update',
                                params: { id: book.id },
                              }"
                              class="btn shadow btn-primary create-new"
                            >
                              Edit
                            </router-link>
                          </div>
                          <div class="col-md-1 text-center">
                            <button
                              class="btn btn-danger"
                              @click="deleteBook(book.id)"
                              v-if="!isReadOnlyUser"
                            >
                              Delete
                            </button>
                          </div>
                          <div class="col-md-1 text-center fabric-action">
                            <span
                              @click="toggleFabricView(index)"
                              v-if="visibleBookFabricIndex != index"
                            >
                              <i class="fa fa-chevron-down"></i>
                            </span>
                            <span
                              @click="hideFabricView()"
                              v-if="visibleBookFabricIndex == index"
                            >
                              <i class="fa fa-chevron-up"></i>
                            </span>
                          </div>

                          <div
                            v-if="
                              book.fabrics.length > 0 &&
                              visibleBookFabricIndex == index
                            "
                            class="col-md-12 fabric-list-container"
                          >
                            <div class="table-div">
                              <table class="table table-bordered table-striped">
                                <thead>
                                  <th class="action-cell"></th>
                                  <th>ID</th>
                                  <th>Name</th>
                                  <th>Status</th>
                                  <th class="action-cell"></th>
                                </thead>
                                <draggable
                                  v-model="book.fabrics"
                                  v-if="book.fabrics.length > 0"
                                  tag="tbody"
                                  @sort="updateFabricOrder"
                                >
                                  <tr
                                    v-for="(fabric, index) in book.fabrics"
                                    :key="fabric.id"
                                  >
                                    <td class="text-center">
                                      <span class="sort-handle"
                                        ><i class="fa fa-bars"></i
                                      ></span>
                                    </td>
                                    <td class="text-bold">
                                      {{ $Fabric.getCode(fabric.id) }}
                                    </td>
                                    <td>
                                      {{ fabric.name }}
                                    </td>
                                    <td>
                                      <span
                                        :class="
                                          'badge badge-' +
                                          getStatusColor(fabric.status)
                                        "
                                      >
                                        {{ fabric.status.replace(/_/g, " ") }}
                                      </span>
                                    </td>
                                    <td class="text-center fabric-action">
                                      <span
                                        @click="
                                          removedFabricFromBook(
                                            book,
                                            fabric,
                                            index
                                          )
                                        "
                                        v-if="!isReadOnlyUser"
                                        ><i class="fa fa-minus"></i
                                      ></span>
                                    </td>
                                  </tr>
                                </draggable>
                              </table>
                            </div>
                          </div>
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold">Select new visibility</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="form-group row">
              <label class="col-sm-5 col-form-label">Visibility</label>
              <div class="col-sm-7">
                <p-radio
                  class="p-default p-curve"
                  color="primary"
                  v-model="visibility"
                  value="public"
                  >Public</p-radio
                >
                <p-radio
                  class="p-default p-curve"
                  color="danger"
                  v-model="visibility"
                  value="private"
                  >Private</p-radio
                >

                <p-radio
                  class="p-default p-curve"
                  color="secondary"
                  v-model="visibility"
                  value="inactive"
                  >Inactive</p-radio
                >
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="updateVisibility()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Fabric from "@/pages/Tools/Fabric";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      categoryId: "",
      books: [],
      selectedBooks: [],
      sortedBook: [],
      visibleBookFabricIndex: -1,
      categoryName: "",
      visibility: null,
      isReadOnlyUser: false,
    };
  },
  async mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    await this.getCategoryDetails();
    await this.loadBooks();
  },
  watch: {
    "$route.params.category": async function () {
      this.selectedBooks = [];
      this.visibleBookFabricIndex = -1;
      await this.getCategoryDetails();
      await this.loadBooks();
    },
  },
  methods: {
    async getCategoryDetails() {
      this.categoryId = this.$route.params.category;
      let response = await axios.get(
        "/v2/fabrics/book-category/" + this.categoryId
      );
      this.categoryName = response.data.data.title;
    },

    async loadBooks() {
      this.categoryId = this.$route.params.category;
      let response = await axios.get(
        "/v2/fabrics/book-category/" + this.categoryId + "/books"
      );
      this.books = response.data.data.collection;
    },
    async searchBookFabric(term) {
      this.categoryId = this.$route.params.category;
      let response = await axios.get(
        "/v2/fabrics/book-category/" + this.categoryId + "/books?term=" + term
      );
      this.books = response.data.data.collection;
    },
    async updateBookOrder(event) {
      let bookIds = this.books.map((f) => f.id);
      try {
        let response = await axios.put(
          "/v2/fabrics/book-category/" + this.categoryId + "/books",
          {
            books: bookIds,
          }
        );
        this.visibleBookFabricIndex = -1;
        toastr.success("Book order successfully updated");
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
    async updateFabricOrder(event) {
      if (this.visibleBookFabricIndex >= 0) {
        let book = this.books[this.visibleBookFabricIndex];
        let fabricIds = book.fabrics.map((f) => f.id);

        try {
          let response = await axios.put(
            `/v2/fabrics/book/${book.id}/fabrics`,
            {
              fabrics: fabricIds,
            }
          );

          if (response.data.status === "OK") {
            toastr.success("The order of the fabrics was successfully changed");
          } else {
            toastr.error(
              "There was an error while tryinh to update the order of the fabrics"
            );
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },
    toggleFabricView(index) {
      this.visibleBookFabricIndex = index;
    },
    hideFabricView() {
      this.visibleBookFabricIndex = -1;
    },
    async deleteBook(bookId) {
      if (await ezy.confirm("Are you sure to delete this book?", "DELETE")) {
        try {
          let response = await axios.delete("/v2/fabrics/book/" + bookId);
          if (response.data.status === "OK") {
            toastr.success("Book deleted successfully");
            await this.loadBooks();
          } else {
            toastr.error("An error occured when trying to delete the book");
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error("An error occurred when trying to delete the book");
          }
        }
      }
    },
    getStatusColor(status) {
      if (["available"].includes(status)) {
        return "primary";
      } else if (
        ["soon_sold_out_not_coming_back", "soon_sold_out_coming_back"].includes(
          status
        )
      ) {
        return "warning";
      } else {
        return "danger";
      }
    },
    getVisibilityColor(visibility) {
      if (visibility === "public") {
        return "primary";
      } else if (visibility === "private") {
        return "danger";
      } else {
        return "secondary";
      }
    },
    async deleteSelected() {
      const selectedBookIds = this.selectedBooks.map((book) => {
        return book.id;
      });
      if (selectedBookIds.length > 0) {
        if (
          await ezy.confirm(
            "Are you sure to delete the selected books?",
            "DELETE"
          )
        ) {
          try {
            let response = await axios.delete("/v2/fabrics/book/delete-all", {
              data: {
                books: selectedBookIds,
              },
            });
            if (response.data.status === "OK") {
              toastr.success("Books deleted successfully");
              this.selectedBooks = [];
              await this.loadBooks();
            } else {
              toastr.error("An error occurred when trying to delete the books");
            }
          } catch (error) {
            if (error.response.status === 403) {
              toastr.error(
                "Not authorized, please ensure that you have the required permissions."
              );
            } else {
              toastr.error("An error occurred when trying to delete the books");
            }
          }
        }
      } else {
        await ezy.confirm("Please select some books !", "OK");
      }
    },
    async updateSelected() {
      const selectedBookIds = this.selectedBooks.map((book) => {
        return book.id;
      });
      if (selectedBookIds.length > 0) {
        show_modal("#modal-box");
      } else {
        await ezy.confirm("Please select some books !", "OK");
      }
    },
    async updateVisibility() {
      const selectedBookIds = this.selectedBooks.map((book) => {
        return book.id;
      });
      if (selectedBookIds.length > 0 && this.visibility) {
        try {
          let response = await axios.put("/v2/fabrics/book/visibility", {
            books: selectedBookIds,
            visibility: this.visibility,
          });
          if (response.data.status === "OK") {
            toastr.success("Books updated successfully");
            hide_modal("#modal-box");
            this.selectedBooks = [];
            await this.loadBooks();
          } else {
            toastr.error("An error occurred when trying to update the books");
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error("An error occurred when trying to update the books");
          }
        }
      }
    },
    async removedFabricFromBook(book, fabric, index) {
      try {
        let response = await axios.delete(
          `/v2/fabrics/book/${book.id}/fabrics`,
          {
            data: {
              fabrics: [fabric.id],
            },
          }
        );
        if (response.data.status === "OK") {
          toastr.success("Fabrics successfully removed from the book");
        }

        // Remove the fabrics from fabric book
        book.fabrics.splice(index, 1);
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
  },
};
</script>

<style scoped>
.book-list-header {
  background-color: var(--primary-color);
  color: white;
  font-size: 14px;
}
.book-list-header div {
  padding: 5px 12px;
  font-weight: bold;
}
.book-list-body div {
  padding: 5px 12px;
}
.book-list-body div.row {
  border-bottom: 1px solid #e8edf1;
}
.book-list-body div.row div {
  border-left: 1px solid #e8edf1;
  min-height: 46px;
  line-height: 30px;
}
.small-cell {
  width: 50px;
}
.medium-cell {
  width: 100px;
}
.bulk-actions .btn {
  margin-left: 15px;
}
.fabric-list-container {
  border-left: none !important;
  padding: 0 !important;
  margin-top: 7px;
}
.fabric-list-container div {
  border-left: none !important;
  border-left: !important;
}
.fabric-list-container .table-div {
  background-color: #f5f5f5;
  padding: 15px 0;
  -moz-box-shadow: inset 0 0 10px #000000;
  -webkit-box-shadow: inset 0 0 10px #000000;
  box-shadow: inset 0px 11px 8px -10px #ccc, inset 0px -11px 8px -10px #ccc;
}
.fabric-list-container .table-div .table {
  margin-bottom: 0;
}
.fabric-list-container .table-div .table th {
  background-color: #555;
}
.fabric-action span {
  background: #767676;
  color: #fff;
  border-radius: 50%;
  display: inline-block;
  width: 20px;
  text-align: center;
  cursor: pointer;
  line-height: 1.5;
}
</style>
